export const SETUP_RETRY = 'SETUP_RETRY';

export default input => async dispatch =>
  dispatch({
    type: SETUP_RETRY,
    payload: input,
  });
